module.exports = __webpack_public_path__ + "media/application/images/2018/kiwi-grey-aef088300306df5f9897c787eea4524b.png";